// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu--vertical .nest-menu .el-submenu > .el-submenu__title[data-v-19e724cb]:hover, .el-menu--vertical .el-menu-item[data-v-19e724cb]:hover {\n  color: white !important;\n}\n.router-link-active:hover span[data-v-19e724cb] {\n  color: white !important;\n}\n.logo[data-v-19e724cb] {\n  box-shadow: 1px 0px 0px 0px #dcdee3;\n}\n", ""]);
// Exports
module.exports = exports;
